import React from "react";
import "./OEMTableStyles.css";
export const getTableHeader = (data) => {
  const { startEngHour, endEngHour, gap } = data;

  const tHeader = [<th className="tableHeaderBorderOEM" colSpan={4} style={{ paddingInline: "25px" }}></th>];
  for (let i = gap; i <= endEngHour; i += gap) {
    tHeader.push(
      <th key={i} className="tableHeaderBorderOEM" style={{ paddingInline: "25px" }}>
        {i}
      </th>,
    );
  }
  return <tr>{tHeader}</tr>;
};

const applyBGcolors = (found, checkItemName, keyValData, iter, engineHour, threshold, TickOrX, TrueSymbol) => {
  let color = {};
  if (iter >= engineHour && iter + threshold > engineHour && iter - threshold > engineHour) {
    return {};
  }
  if (found) {
    // Iterate through all entries for the same engine hour
    for (const entry of keyValData[found]) {
      if (entry[checkItemName]) {
        if (entry[checkItemName] === "true") {
          TickOrX.item = TrueSymbol;
          return clGreen;
        } else {
          return clRed;
        }
      }
    }
    return clRed; // If no matching entry has a "true" value
  }
  return (color = clRed);
};

const groupTheDataInThresholdRange = (keyVal, gap, endEngHour, threshold) => {
  const keysOfData = Object.keys(keyVal).map(Number);
  const ObjectFinal = {};
  const addedKeys = new Set();

  for (let i = gap; i <= endEngHour; i += gap) {
    const foundKeys = keysOfData.filter((key) => !addedKeys.has(key) && Math.abs(key - i) <= threshold);

    if (foundKeys.length > 0) {
      foundKeys.forEach((key) => addedKeys.add(key));
      ObjectFinal[i] = foundKeys.reduce((acc, key) => {
        // Combine arrays of objects for the same interval
        return [...acc, ...(Array.isArray(keyVal[key]) ? keyVal[key] : [keyVal[key]])];
      }, []);
    }
  }

  return ObjectFinal;
};

export const getSingleRow = (obj, keyValData, engineHour, data) => {
  const { startEngHour, endEngHour, gap, threshold } = data;
  const { checkItemName, freq, startHour } = obj;

  const tRow = [
    <td colSpan={4} style={{ paddingInline: "15px" }}>
      {checkItemName}
    </td>,
  ];

  // Get grouped data where multiple activities can be associated with the same engine hour
  let groupedDataObject = groupTheDataInThresholdRange(keyValData, gap, endEngHour, threshold);
  const keysOfData = Object.keys(groupedDataObject);

  for (let i = gap, k = 0; i <= endEngHour; i += gap, k += 1) {
    if ((k + 1) % freq === 0) {
      let found = keysOfData.find((e) => e == i);
      let TickOrX = { item: "X" };
      // Apply background colors based on the updated structure (array of objects)
      tRow.push(
        <td key={i} style={applyBGcolors(found, checkItemName, groupedDataObject, i, engineHour, threshold, TickOrX, "✓")}>
          {TickOrX.item}
        </td>,
      );
    } else {
      let found = keysOfData.find((e) => e == i);
      let TickOrX = { item: "" };
      tRow.push(
        <td key={i} style={applyBGcolors(found, checkItemName, groupedDataObject, i, engineHour, threshold, TickOrX, "+")}>
          {TickOrX.item}
        </td>,
      );
    }
  }

  return tRow;
};

export const getTableBody = (obj, asset, data) => {
  const { assetStates } = asset;
  const engineHour = assetStates ? (assetStates.engineHour ? assetStates.engineHour : 0) : 0;
  const { table } = data;
  const tableBody = table.map((item, index) => {
    return <tr key={index}>{getSingleRow(item, obj, engineHour, data)}</tr>;
  });
  return tableBody;
};

const clRed = {};
const clGreen = {
  color: "green",
  fontSize: "x-large",
  fontWeight: "700",
};
const NoBG = {};



// WEBPACK FOOTER //
// ./src/components/LocomotiveOEMRecord/OEM_HelperFunctions.jsx